<template>
  <div class="customer-message">
    <a-affix :offset-top="top" class="message-affix">
      <a-button type="danger" @click="showDrawer">
        <a-icon type="menu-unfold" />
        目录
      </a-button>
    </a-affix>
    <a-card key="1" tab="企业基本信息" class="margin-bottom-30" id="mod1">
      <a-skeleton active :loading="skeletonLoding">
        <base-form
          v-if="detail && detail.base"
          :permissions="permissions['客户信息']"
          :customerDetail="detail"
          @hanleDetail="_customerDetail"
        ></base-form>
      </a-skeleton>
    </a-card>
    <a-card key="2" tab="企业地址信息" class="margin-bottom-30" id="mod2">
      <a-skeleton active :loading="skeletonLoding">
        <address-form
          v-if="detail && detail.base"
          :permissions="permissions['客户信息']"
          :customerDetail="detail"
          @hanleDetail="_customerDetail"
        ></address-form>
      </a-skeleton>
    </a-card>
    <a-card key="3" tab="企业账户管理" class="margin-bottom-30" id="mod3">
      <a-skeleton active :loading="skeletonLoding">
        <account-form
          v-if="detail && detail.base"
          :permissions="permissions['客户信息']"
          :customerDetail="detail"
          @hanleDetail="_customerDetail"
        ></account-form>
      </a-skeleton>
    </a-card>
    <a-card key="4" tab="信用主管信息" class="margin-bottom-30" id="mod4">
      <a-skeleton active :loading="skeletonLoding">
        <contact-info
          v-if="detail && detail.base"
          :permissions="permissions['客户信息']"
          :customerDetail="detail"
          :skeletonLoding="skeletonLoding"
          @hanleDetail="_customerDetail"
        ></contact-info>
      </a-skeleton>
    </a-card>
    <a-card key="5" tab="客户背景资料调查表" class="margin-bottom-30" id="mod5">
      <a-skeleton active :loading="skeletonLoding">
        <background-form
          v-if="detail && detail.base"
          :permissions="permissions['客户信息']"
          :customerDetail="detail"
          @hanleDetail="_customerDetail"
        ></background-form>
      </a-skeleton>
    </a-card>
    <a-card key="6" tab="企业额外信息" class="margin-bottom-30" id="mod6">
      <a-skeleton active :loading="skeletonLoding">
        <extra-info
          v-if="detail && detail.base"
          :permissions="permissions['客户信息']"
          :customerDetail="detail"
          @hanleDetail="_customerDetail"
        ></extra-info>
      </a-skeleton>
    </a-card>
    <!--锚点-->
    <a-drawer
      placement="right"
      :closable="false"
      :visible="visible"
      @close="onClose"
    >
      <p>目录</p>
      <a-anchor @click="handleClick">
        <a-anchor-link href="#mod1" title="1.企业基本信息" />
        <a-anchor-link href="#mod2" title="2.企业地址信息" />
        <a-anchor-link href="#mod3" title="3.企业账户管理" />
        <a-anchor-link href="#mod4" title="4.信用主管信息" />
        <a-anchor-link href="#mod5" title="5.客户背景资料调查表" />
        <a-anchor-link href="#mod6" title="6.企业额外信息" />
      </a-anchor>
    </a-drawer>
  </div>
</template>
<script>
import BaseForm from './components/BaseForm'
import AddressForm from './components/AddressForm'
import ExtraInfo from './components/ExtraInfo'
import AccountForm from './components/AccountForm'
// import ContactForm from './components/ContactForm'
import BackgroundForm from './components/BackgroundForm'
import { customerDetail } from './api'
import { mapMutations, mapGetters } from 'vuex'
import ContactInfo from './components/ContactInfo.vue'
export default {
  components: {
    BaseForm,
    AddressForm,
    ExtraInfo,
    AccountForm,
    // ContactForm,
    BackgroundForm,
    ContactInfo,
  },
  data() {
    return {
      // permissions: [],
      detail: {},
      skeletonLoding: true,
      targetOffset: undefined,
      visible: false,
      top: 100,
    }
  },
  mounted() {
    this.targetOffset = window.innerHeight / 2
    this.clientId = this.$route.params.id
    // this._getCustomerOverview()
    this._customerDetail()
  },
  computed: {
    ...mapGetters('app', ['permissions']),
  },
  methods: {
    ...mapMutations('app', [
      'SET_COMPANYCODE',
      'SET_CUSTOMER_INFO',
      'SET_CUSTOMER_DETAIL',
    ]),
    //客户权限
    // async _getCustomerOverview() {
    //   try {
    //     const { data } = await getCustomerOverview(this.clientId)
    //     //this.loading = false
    //     this.permissions = data.permissions
    //   } catch (err) {
    //     console.log(err)
    //   }
    // },
    //客户详情
    _customerDetail() {
      customerDetail(this.$route.params.id).then(({ data }) => {
        this.detail = data
        this.skeletonLoding = false
      })
    },
    // 锚点
    handleClick(e, link) {
      e.preventDefault()
      this.$router.push({
        name: 'message',
        params: { mod: link.href.slice(1, 5) },
      })
    },
    showDrawer() {
      this.visible = true
    },
    onClose() {
      this.visible = false
    },
  },
}
</script>
<style lang="less" scoped>
.customer-message {
  position: relative;
  width: 100%;
  background-color: #f0f2f5;
  /deep/ .margin-bottom-30 {
    margin-bottom: 30px;
  }
  /deep/ .margin-bottom-20 {
    margin-bottom: 20px;
  }
  /deep/ .message-affix {
    position: absolute;
    right: 0;
    top: 20px;
  }
  /deep/ .ant-affix {
    right: 0;
  }
}
</style>
